import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaSpinner, FaArrowLeft } from 'react-icons/fa';
import api from '../api/api';
import BrandPanel from './BrandPanel';

const ForgotPasswordPage = () => {
    const location = useLocation();
    const [ email, setEmail ] = useState((location.state as any)?.email || '');
    const [ sent, setSent ] = useState(false);
    const [ error, setError ] = useState('');
    const [ loading, setLoading ] = useState(false);

    const send = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            await api().forgotPassword(email.trim());
            setSent(true);
        } catch {
            setError('Could not send the reset link, please try again');
        }
        setLoading(false);
    };

    return <div className="login-page">
        <BrandPanel />
        <div className="form-panel">
            <form className="login-box" onSubmit={send}>
                <img className="form-logo" src="/images/login/logo-mobile.svg" alt="Investi" />
                <Link to="/login" className="back-link"><FaArrowLeft size={12} /> Back to sign in</Link>
                { !sent && <>
                    <div className="heading">
                        <h2>Forgot your password?</h2>
                        <p>No worries. Enter the email address for your Investi account and we'll send you a link to reset it.</p>
                    </div>
                    <div className="field">
                        <label htmlFor="forgot-email">Email address</label>
                        <div className="input-row">
                            <input id="forgot-email" type="email" autoComplete="username" value={email} onChange={e => setEmail(e.target.value)} disabled={loading} autoFocus required />
                        </div>
                    </div>
                    {error && <p className="error">{error}</p>}
                    <button type="submit" disabled={loading || !email.trim()}>Send Reset Link &nbsp;
                        { loading && <FaSpinner className="fa-spin" size={16} color="#0b1739" />}
                    </button>
                </> }
                { sent && <div className="heading">
                    <h2>Check your email</h2>
                    <p>If <strong>{email.trim()}</strong> belongs to an Investi account, a reset link is on its way. Not arrived within a minute? Check your spam folder for an email from notifications@investi.com.au.</p>
                </div> }
                <div className="callout">
                    <span className="callout-icon">i</span>
                    <p>For security we'll send the link only if this email belongs to an account. It expires after 30 minutes and can be used once.</p>
                </div>
                <div className="help">
                    <span>Still can't get in?</span> <a href="mailto:contact@investi.com.au">Contact support</a>
                </div>
            </form>
        </div>
    </div>;
};

export default ForgotPasswordPage;
